<template>
  <div ref="fristhome">
    <el-card class="box-card">
      <el-form label-width="120px" :inline="true" size="mini"
               :model="addForm"
               ref="addForm"
               :rules="rules">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="车牌号" >
              <el-input style="width: 180px;" v-model="addForm.plate_number" prefix-icon="el-icon-search" @click.native.prevent="chooseCar"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型" prop="allPerson">
              <el-input style="width: 180px;" v-model="addForm.vehicle_type"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车架号" prop="remark">
              <el-input style="width: 180px;":disabled="true"  v-model="addForm.vin"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="被保险人名称" prop="owner_name">
              <el-input style="width: 180px;"  :disabled="true" v-model="addForm.owner_name"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="被保险人证件号" prop="owner_idcard">
              <el-input style="width: 180px;" v-model="addForm.owner_idcard"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="被保险人电话" prop="owner_mobile">
              <el-input style="width: 180px;" v-model="addForm.owner_mobile"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="投保人名称"   prop="insured">
              <el-input style="width: 180px;" :disabled="true" v-model="addForm.toubao_name"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投保人证件号" prop="insured_idcard">
              <el-input style="width: 180px;" v-model="addForm.toubao_idcard"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投保人电话" prop="insured_tel">
              <el-input style="width: 180px;" v-model="addForm.toubao_mobile"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="table_box">
              <div style="text-align: left;padding:10px 0;">
                <el-button type="primary" size="mini" @click="addItem">新增保险产品</el-button>
              </div>
              <el-table :data="list" v-horizontal-scroll="'always'" border  size="mini" :summary-method="getSummaries" show-summary style="width: 100%;" stripe height="260">
                <el-table-column prop="product_id" width="130px" label="保险产品名称" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.product_name}}</span>
                    <el-select
                        v-if="scope.row.isEgdit"
                        v-model="scope.row.product_id"
                        size="mini"
                        clearable
                        placeholder="请选择产品">
                      <el-option
                          v-for="item in pList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column width="200px" label="保司" align='center'>
                  <template slot-scope="scope">
<!--                    @change="(query)=>{getline(query,scope.$index)}"-->
                    <el-select
                        v-model="scope.row.corp_id"
                        filterable 
                        default-first-option
                        size="mini"
                        placeholder="请输入保司"
                        clearable
                    >
                      <el-option
                          v-for="item in corpList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>

                  </template>
                </el-table-column>
                <el-table-column width="100px"  label="保费" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.real_price}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.real_price"></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="100px"  label="净费" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.sell_price}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.sell_price"></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="180px"  label="投保日期" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.effective_date}}</span>

                    <el-date-picker
                        size="mini"
                        style="width: 150px;"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions1"
                        v-if="scope.row.isEgdit"
                        v-model="scope.row.effective_date"
                        type="datetime"
                        placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column width="180px"  label="保险起期" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.start_time}}</span>
                    <el-date-picker
                        @change="startDateChange($event,scope.$index)"
                        size="mini"
                        style="width: 150px;"
                        value-format="yyyy-MM-dd"
                        v-if="scope.row.isEgdit"
                        v-model="scope.row.start_time"
                        type="date"
                        placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column width="180px" label="保险止期" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.end_time}}</span>
                    <el-date-picker
                        size="mini"
                        style="width: 150px;"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        v-if="scope.row.isEgdit"
                        v-model="scope.row.end_time"
                        type="datetime"
                        placeholder="选择投保日期">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="渠道联系人" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.link_name}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.link_name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="link_tel" label="渠道联系电话" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.link_tel}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.link_tel"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">{{scope.row.remark}}</span>
                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="sy_policy_no" label="商业险保单号" align='center'>
                  <template slot-scope="scope">

                    <el-input size="mini" v-if="scope.row.isEgdit" v-model="scope.row.sy_policy_no"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="link_tel" label="保单" align='center'>
                  <template slot-scope="scope">
                    <span v-if="!scope.row.isEgdit">查看保单</span>
                    <el-upload
                        drag
                        class="avatar-uploader"
                        action="#"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="(file, fileList) => {handleChange(file, fileList, scope.$index)}"
                        :multiple=false
                        :file-list="scope.row.fileList"
                        :limit="1"

                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                      <img v-if="scope.row.file_url" :src="scope.row.file_url" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column width="130px" label="操作" align='center'>
                  <template slot-scope="scope">

                    <el-button @click.native.prevent="deleteItem(scope.$index, list)" type="danger" size="mini" icon="el-icon-delete" circle></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col style="display:flex;flex-direction: row;justify-content: flex-end">
            <el-form-item>
              <el-button @click="close">取消</el-button>
              <el-button type="primary" @click="save('addForm')">保存</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <eCar :carVisibleProp.sync="isShowCar" v-on:eventCar="chooseCarInfo"/>
    <!---->
    <el-dialog width="60%" title="产品列表" :visible.sync="productVisible" @close="closeProduct">
      <el-form size="mini" :model="searchForm" ref="searchForm" :inline="true">
        <el-form-item label="产品名称" prop="keywords">
          <el-input   v-model="searchForm.keywords" palceholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-button type="primary">查询</el-button>
        </el-form-item>
        <div>
          <el-table :data="productList" border  size="mini" style="width: 100%;" stripe height="260">
            <el-table-column label="选择" align="center" width="55">
              <template slot-scope="scope">
                <el-radio :label="scope.$index" v-model="pIndex"
                          @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column
                prop="name"
                label="产品名称"
            >
            </el-table-column>
          </el-table>
        </div>
        <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="productVisible = false">取消</el-button>
            <el-button  size="mini" type="primary" @click="okProduct">确定</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!---->

  </div>
</template>
<script>
import horizontalScroll from 'el-table-horizontal-scroll'
import eCar from "../common/eCar";
import moment from 'moment'
import Watermark from "../../utils/waterMark";
export default {

  name:'otherAddInsurance',
  props:['carVisibleProp'],
  components: {
    eCar
  },
  directives: {
    horizontalScroll
  },
  data(){
    return {
      pickerOptions1:{
        disabledDate(time) {
          return time.getTime() >= Date.now() ;
        }
      },
      ownerLoading:false,
      ownerList:[],
      ownerStates:[],


      corp:'',
      corpLoading:'',
      corpList:[],
      corpStates:[],


      pLoading:'',
      pList:[],
      pStates:[],

      isShowCar:false,

      productList:[],
      productVisible:false,
      index:0,
      pIndex:0,
      productId:[],
      options: [],
      carList: [],
      loading: false,
      states: [],

      searchForm:{
        keywords:'',
      },
      searchRules:{

      },
      addForm:{
        vin:"",
        shop_id:'',
        plate_number:'',
        vehicle_type:'',
        car_id:'',
        owner_id:'',
        owner_mobile:'',
        owner_idcard:'',
        owner_name:'',
        toubao_name:"",
        toubao_idcard:"",
        toubao_mobile:"",
        remark:'',
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      },
      rules: {
        owner_name: [{ required: true, message: '请输入投保人', trigger: 'blur' }],
        toubao_name: [{ required: true, message: '请输入被投保人', trigger: 'blur' }],
      },
      title:'保单新增',
      car_number:'',
      fileList:[],
      activeName: 'first',
      insurance_date:'',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      list: [],
    }
  },
  mounted() {
    this.carList = this.states.map(item => {
      return { value: `${item}`, label: `${item}` };
    });
    //console.log('111',this.carList)
    this.getProductList();
    this.corpDataList()
    let str = sessionStorage.getItem('userName')+' '+moment().format("yyyy-MM-DD HH:mm:ss")
    this.$nextTick(() => { //要加载完才能获取$refs
      Watermark.set(str,this.$refs.fristhome)
    })
  },
  methods:{
    handleAvatarSuccess(){

    },
    beforeAvatarUpload(){

    },
    // 新增
    addData() {
      this.$router.push('/insuranceAdd');
    },
    addByProduct(){
      this.$router.push('/insuranceAddByProduct');
    },
    addSysProduct(){
      this.$router.push('/insuranceSysProduct');
    },
    addSysCar(){
      this.$router.push('/insuranceSysCar');
    },
    ownerChange(owner_id){

    },
    getCurrentRow(row){
      if(this.list.length>0){
        for (var i=0;i<this.list.length;i++){
          if(this.list[i].product_id==row.id){
            this.$message.error('保险不能重复添加')
            return;
          }
        }
      }
      this.list[this.index].product_name=row.name;
      this.list[this.index].product_id=row.id;

    },
    getProductList(){
      const param = {
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
      }
      this.$axios.insuranceProdcutList(param).then(res=>{
        if(res.code == 200){
          this.productList = res.data.data;
          this.pList=res.data.data;
        }
      }).catch(error=>{
        //console.log(error);
      })
    },
    ownerRemoteMethod(query){
      let _this=this;
      if (query !== '') {
        this.ownerLoading = true;
        let param={
          queryParams:query,
          operator_id:sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }

        //console.log('param------',param)

        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.ownerStates = res.data.data;
          }
        }).catch(error=>{
          //console.log(error);
        })
        setTimeout(() => {
          this.ownerLoading = false;
          this.ownerList = this.ownerSet.filter(item => { // 这里的this.list，换为this.ownerSet
            return item.name;
          });
        }, 1000);
      } else {
        this.ownerList = [];
      }
    },
    //保司选择变动时 触发
    getline(rows,index){
      let ids=[];
      this.corpList.forEach(function(e){
        ids.push(e.id);
      });
      //console.log('id列表：',ids)

      if(!ids.includes(rows)){
        this.list[index].corp_id = '';
        this.list[index].corp_name = rows
      }

      //console.log('触发：',rows)
    },
    corpDataList(){
      let param={
        company_id:sessionStorage.getItem('company_id'),
        access_token:sessionStorage.getItem('token'),
        page:1,
        limit:1000
      }
      this.$axios.corpList(param).then(res=>{
        if(res.code == 200){
          this.corpList = res.data.data;
        }
      }).catch(error=>{
        //console.log(error);
      })
    },

    corpRemoteMethod(query,index){
      ////console.log('---query---',query,index)
      if (query !== '') {
        this.corpLoading = true;
        let param={
          queryParams:query,
          //operator_id:sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.corpList(param).then(res=>{
          if(res.code == 200){
            this.corpStates = res.data.data;
          }
        }).catch(error=>{
          //console.log(error);
        })
        setTimeout(() => {
          this.corpLoading = false;
          this.corpList = this.corpSet.filter(item => {
            return item.name;
          });
          if(this.corpList.length<=0)
          {
            this.list[index].corp_name = query
          }
        }, 1000);
      } else {
        this.corpList = [];
      }
    },
    pRemoteMethod(query){
      if (query !== '') {
        this.pLoading = true;
        let param={
          queryParams:query,
          operator_id:sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.insuranceProdcutList(param).then(res=>{
          if(res.code == 200){
            this.pStates = res.data.data;
          }
        }).catch(error=>{
          //console.log(error);
        })
        setTimeout(() => {
          this.pLoading = false;
          this.pList = this.pSet.filter(item => {
            return item.name;
          });
        }, 1000);
      } else {
        this.pList = [];
      }
    },
    chooseCarInfo(plate_number,...params){
      this.addForm.plate_number=plate_number;
      this.addForm.vin=params[3];
      this.addForm.car_id=params[0];
      this.addForm.vehicle_type=params[1];
      this.addForm.toubao_name=params[2];
      this.addForm.shop_id=params[4];

      this.addForm.owner_id=params[4];
      this.addForm.owner_name=params[2];
      this.ownerList = this.ownerStates.map(item => {
        return { value: item.value, label: item.label };
      });
      this.ownerRemoteMethod(params[2]);//调用远程搜索函数


    },
    handleClick(){

    },
    closeProduct(){

    },
    okProduct(){
      this.productVisible=false;
    },
    chooseProduct(index){
      this.productVisible=true;
      this.index=index;
      ////console.log('list0-------',this.list)
    },
    chooseCar(){
      this.isShowCar=true;
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.carList.filter(item => {
            return item.name.indexOf(query) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    onClose(){
      this.$emit('close')
    },
    close(){
      this.$emit('close')
    },
    handleBeforeUpload(){

    },
    uploadSuccess(){

    },
    handleChange(file,fileList,index){
      let _this=this;

      //------上传到阿里云
      let carFd = new FormData()
      carFd.append('file', file.raw)
      carFd.append('file_type', 1)
      // carFd.append('file_value', this.addForm.vin)
      carFd.append('company_id', sessionStorage.getItem('company_id'))
      carFd.append('access_token', sessionStorage.getItem('token'))
      this.$axios.ossUploadFile(carFd).then(res11 => {

        //console.log('aliyun--------',res11)
        if (res11.code == 200) {
          this.$message.success(res11.msg)
          _this.list[index].file_url = res11.data.src;
          //console.log('file_url--------', _this.list[index].file_url)

        } else if (res11.code == 1) {
          this.$message.error(res11.msg)
        }
      }).catch(function (error) {
        //console.log(error);
      })
      //------上传到阿里云
    },
    save(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //console.log('savelist',this.list)
          if(this.list.length<1){
            this.$message.error("保险产品必选")
            return;
          }
          for(var i=0;i<this.list.length;i++){
            var pid=this.list[i].product_id;
            if(isNaN(pid)||pid==null || pid==undefined || pid ==''){
              this.$message.error("请选择保险产品")
              return;
            }
            var efDate=this.list[i].effective_date;
            if(efDate==null || efDate==undefined || efDate ==''){
              this.$message.error("请选择投保日期")
              return;
            }
            var sDate=this.list[i].start_time;
            if(sDate==null || sDate==undefined || sDate ==''){
              this.$message.error("请选择保险起期")
              return;
            }
            var eDate=this.list[i].end_time;
            if(eDate==null || eDate==undefined || eDate ==''){
              this.$message.error("请选择保险止期")
              return;
            }
            // 创建两个日期对象
            var date1 = moment(efDate, 'YYYY-MM-DD');
            var date2 = moment(sDate, 'YYYY-MM-DD');
            var date3 = moment(eDate, 'YYYY-MM-DD');
            // if (date2.isBefore(date1)) {
            //     this.$message.error("保险起期要大于投保日期")
            //     return;
            // }
            if (date3.isBefore(date2)) {
              this.$message.error("保险止期要大于保险起期")
              return;
            }
          }
          let param = this.addForm;
          param.shop_id=param.owner_id;
          param.productList=this.list;
          for(var i=0;i<param.productList.length;i++){
            if(param.productList[i].corp_name)
            {
              param.productList[i].corp_id = ''
            }
          }
          //console.log('param------',param);

          this.$axios.saveGroupByCar(param).then(res =>{ //saveGroupByCar
            if(res.code == 200){
              this.$message.success(res.msg)
              this.$router.push('/insuranceTeamOrder')
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      });
    },
    dealSpace(str){
      return str.replace(/&nbsp;/gi, " ");
    },
    //合计 表格每一列需要带上prop
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总数量';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += '(个)';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //新增数据
    addItem() {
      if(!this.addForm.plate_number){
        this.$message.error('请选择车辆，然后新增保险产品');
        return false;
      }
      let item = {
        id: null,
        product_name:'',
        product_id:'',
        price:0,
        real_price:0,
        sell_price:0,
        effective_date:this.getNowTime(),
        start_time:'',
        end_time:"",
        fruitSort: null,
        firstNum: null,
        isEgdit: true,
        product_md_id:'',
        sy_policy_no:'',
        corp_id:'',
        corp_name:'',
        type:1,
        account:111111,
        account_number:'11111',
        file_url:'',
        pay_id:'888',
        proposal_form:'',
        fileList:[],
      }
      this.list.push(item)
    },
    //删除数据
    deleteItem(index, list) {
      list.splice(index, 1);
    },
    //编辑数据
    edit(index, row) {
      this.$set(row, 'isEgdit', true)
    },
    //编辑成功
    editSuccess(index, row) {
      this.$set(row, 'isEgdit', false)
    },
    startDateChange(date,idx){

      // this.list[idx].start_time=date;
      // let tmp1=new Date(date);
      // var tmp= moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('yyyy-MM-DD 23:59:59');
      // this.list[idx].end_time=moment(tmp).subtract(+1, 'days').format('yyyy-MM-DD 23:59:59');

      var tmp1=new Date(date);
      let tmp= moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('yyyy-MM-DD 23:59:59');
      this.list[idx].end_time=moment(tmp).subtract(+1, 'days').format('yyyy-MM-DD 23:59:59');
      if(tmp1.getFullYear()%4==0){
        if(tmp1.getMonth()==1&&tmp1.getDate()==29){
          this.list[idx].end_time=moment(tmp1.getFullYear()+"-"+(tmp1.getMonth()+1)+'-'+tmp1.getDate()).add(1, 'y').format('yyyy-MM-DD 23:59:59');
        }
      }
    },
    //处理默认选中当前日期
    getNowTime(y=0,m=0,d=0) {
      return moment().format("yyyy-MM-DD HH:mm:ss");
      // var now = new Date();
      //
      // var year = now.getFullYear()+y; //得到年份
      // var month = now.getMonth(); //得到月份
      // var date = now.getDate()+d; //得到日期
      // var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      // month = month + 1+m;
      // month = month.toString().padStart(2, "0");
      // date = date.toString().padStart(2, "0");
      // var defaultDate = `${year}-${month}-${date}${hour}`;
      // //console.log(defaultDate)
      // return defaultDate;
      //this.$set(this.addForm, "effective_date", defaultDate);
    },
  },
  computed: {
    ownerSet() {
      return this.ownerStates.map(item => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },
    corpSet() {
      return this.corpStates.map(item => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    },
    pSet() {
      return this.pStates.map(item => {
        return { id: `${item.id}`, name: `${item.name}` };
      });
    }
  },
}
</script>
<style lang="less" scoped>
//https://www.yzktw.com.cn/post/1262748.html


/deep/.el-upload-dragger {
  width: 50px !important;
  height: 50px !important;
}
.upload_group {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .upload_list {
    width: 100px;
    margin-right: 1rem;

  }

  /deep/.el-upload-dragger .el-upload__text {
    font-size: 10px;
    color: #409EFF;
  }

  /deep/.el-icon-upload:before {
    width: 30px !important;
    height: 30px !important;
  }
  .upload_list:last-child {
    margin-right: 0;
  }

  /deep/.el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border: 1px solid #999;
  }

  /deep/.el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger .el-icon-upload {
    margin: 10px 0;
  }
}
.table_name:hover{
  color: #409EFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/insurance/otherAddInsurance.vue